import { Dialog, DialogActions, DialogTitle, Slide, Typography, Box, Button, useTheme, useMediaQuery } from '@mui/material';
/* eslint-disable */
import { useState, useEffect, forwardRef } from 'react';
import OTPInput from 'react-otp-input';
import { forgotMpinApi, forgotMpinOtpApi } from 'utils/API/Merchant APIs/MpinApiCalls';
import Spinner from 'views/Components/LoadingSinner';
import { globalNotifySuccess } from 'views/utilities/AlertToast';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const inputStyle = {
    width: '36px',
    height: '42px',
    margin: '0 4px',
    borderRadius: '10px',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    background: 'rgba(255,255,255,0.3)',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
    fontSize: '1.4rem',
    color: '#1A202C',
    textAlign: 'center',
    outline: 'none',
    fontWeight: 500,
    transition: 'all 0.3s ease',
    backdropFilter: 'blur(4px)'
};

const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '0.5rem'
};
export default function ForgotMpinDialog({ open, onClose, onSubmit, onSuccess, data }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [token, setToken] = useState('');
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);
    const [lat, setLat] = useState(null);
    const [lng, setLng] = useState(null);
    const [formData, setFormData] = useState({
        mobile: '',
        newMpin: '',
        confirmMpin: ''
    });
    const [errors, setErrors] = useState({});

    const handleForgotMpinOtp = async () => {
        setLoading(true);
        try {
            const payload = {
                mpin: formData.newMpin,
                settype: 'resent',
                confirm_mpin: formData.confirmMpin,
                agentid: localStorage.getItem('id') || ''
            };
            const response = await forgotMpinOtpApi(payload, localStorage.getItem('accessToken'), lat, lng);
            if (response?.data?.success || response?.status === 200) {
                setToken(response?.data?.validate_token || '');
                globalNotifySuccess('OTP sent successfully');
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error.message);
            handleCatchError(error);
        }
    };

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const lat = position.coords.latitude;
                const long = position.coords.longitude;
                localStorage.setItem('latitude', lat);
                localStorage.setItem('longitude', long);
                setLat(lat);
                setLng(long);
            },
            (error) => {
                console.error('Error getting location:', error);
            }
        );
    }, []);

    const handleForgotMpin = async () => {
        setLoading(true);
        try {
            const payload = {
                mpin: formData.newMpin,
                confirm_mpin: formData.confirmMpin,
                validate_token: token,
                otp,
                settype: 'resent',
                confirm_mpin: formData.confirmMpin,
                agentid: localStorage.getItem('id') || ''
            };
            const response = await forgotMpinApi(payload, localStorage.getItem('accessToken'), lat, lng);
            if (response?.data?.success || response?.status === 200) {
                setToken('');
                setOtp('');
                setFormData({ mobile: '', newMpin: '', confirmMpin: '' });
                globalNotifySuccess('OTP sent successfully');
                onClose?.();
                if (onSuccess) onSuccess();
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error.message);
            handleCatchError(error);
        }
    };

    useEffect(() => {
        if (otp.length === 6 && token) {
            handleForgotMpin();
        }
    }, [otp, token]);

    useEffect(() => {
        if (open) {
            setFormData({ mobile: '', newMpin: '', confirmMpin: '' });
            setErrors({});
        }
    }, [open]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'otp') {
            if (/^\d{0,6}$/.test(value)) {
                setOtp(value);
            }
        } else if ((name === 'newMpin' || name === 'confirmMpin') && /^\d{0,6}$/.test(value)) {
            setFormData({ ...formData, [name]: value });
        }
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose?.();
                }
            }}
            PaperProps={{
                sx: {
                    width: isMobile ? '90vw' : '400px',
                    borderRadius: 5,
                    p: 2.2,
                    background: 'rgba(255, 255, 255, 0.7)',
                    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.18)'
                }
            }}
        >
            <DialogTitle
                sx={{
                    fontWeight: 700,
                    fontSize: '1.2rem',
                    color: '#222',
                    textAlign: 'left',
                    px: 0
                }}
            >
                Forgot MPIN
            </DialogTitle>
            {!token ? (
                <Box display="flex" flexDirection="column" gap={2}>
                    <Box>
                        <Typography variant="subtitle2" mb={0.5}>
                            New MPIN
                        </Typography>
                        <OTPInput
                            key="newMpin"
                            value={formData.newMpin}
                            onChange={(value) => handleChange({ target: { name: 'newMpin', value } })}
                            numInputs={6}
                            isInputSecure={true}
                            shouldAutoFocus={true}
                            inputStyle={inputStyle}
                            containerStyle={containerStyle}
                            renderSeparator={<span style={{ width: '8px' }} />}
                            renderInput={(props) => <input {...props} />}
                        />

                        {errors.newMpin && (
                            <Typography variant="caption" color="error">
                                {errors.newMpin}
                            </Typography>
                        )}
                    </Box>

                    <Box>
                        <Typography variant="subtitle2" mb={0.5}>
                            Confirm MPIN
                        </Typography>
                        <OTPInput
                            key="confirmMpin"
                            value={formData.confirmMpin}
                            onChange={(value) => handleChange({ target: { name: 'confirmMpin', value } })}
                            numInputs={6}
                            isInputSecure={true}
                            inputStyle={inputStyle}
                            containerStyle={containerStyle}
                            renderSeparator={<span style={{ width: '8px' }} />}
                            renderInput={(props) => <input {...props} />}
                        />

                        {errors.confirmMpin && (
                            <Typography variant="caption" color="error">
                                {errors.confirmMpin}
                            </Typography>
                        )}
                    </Box>
                </Box>
            ) : (
                <Box display="flex" flexDirection="column" gap={2}>
                    <Box>
                        <Typography variant="subtitle2" mb={0.5}>
                            OTP
                        </Typography>
                        <OTPInput
                            key="otp"
                            value={otp}
                            onChange={(value) => handleChange({ target: { name: 'otp', value } })}
                            numInputs={6}
                            isInputSecure={true}
                            shouldAutoFocus={true}
                            inputStyle={inputStyle}
                            containerStyle={containerStyle}
                            renderSeparator={<span style={{ width: '8px' }} />}
                            renderInput={(props) => <input {...props} />}
                        />
                    </Box>
                </Box>
            )}
            {!token ? (
                <DialogActions sx={{ mt: 2, justifyContent: 'space-between' }}>
                    <Button
                        onClick={() => {
                            onSuccess();
                            onClose();
                        }}
                        variant="text"
                    >
                        Cancel
                    </Button>
                    <Button onClick={handleForgotMpinOtp} variant="text">
                        Submit
                    </Button>
                </DialogActions>
            ) : (
                <DialogActions sx={{ mt: 2, justifyContent: 'flex-end' }}>
                    <Button onClick={handleForgotMpinOtp} variant="text">
                        Resend
                    </Button>
                </DialogActions>
            )}
            <Spinner loading={loading} />
        </Dialog>
    );
}
